module.exports = __webpack_public_path__ + "media/music_40.37762e0a.mp3";